export const recordsFactoryABI = [
  {
    inputs: [
      { internalType: "string", name: "_name", type: "string" },
      { internalType: "uint8", name: "_age", type: "uint8" },
      { internalType: "string", name: "_gender", type: "string" },
      { internalType: "string", name: "_bloodgroup", type: "string" },
      { internalType: "string", name: "_patientaddress", type: "string" },
      { internalType: "string", name: "_patientillness", type: "string" },
      {
        internalType: "string",
        name: "_patientmedicalrecords",
        type: "string",
      },
    ],
    name: "createRecord",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getRecords",
    outputs: [{ internalType: "address[]", name: "", type: "address[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "", type: "address" },
      { internalType: "uint256", name: "", type: "uint256" },
    ],
    name: "records",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
];
